import { useState, useEffect } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'

const getSelectValue = (filter, query) => {
  if (!filter.items) return []

  return filter.items.filter((item) => {
    if (Array.isArray(query[filter.name])) {
      return query[filter.name].includes(String(item.value))
    }

    return query[filter.name] === item.value
  })
}

function FilterSelect({ filter, query, setQuery }) {
  const [selectValue, setSelectValue] = useState(getSelectValue(filter, query))

  useEffect(() => {
    setSelectValue(getSelectValue(filter, query))
  }, [query, filter])

  const handleSelectChange = (items) => {
    if (!items.length) {
      setQuery((query) => ({ ...query, [filter.name]: undefined }))
    }

    setQuery((query) => ({
      ...query,
      [filter.name]: items.map((it) => String(it.value)),
    }))
  }

  return (
    <Autocomplete
      value={selectValue}
      options={filter.items}
      renderTags={() => {}}
      getOptionLabel={(option) => option.label}
      onChange={(e, value) => handleSelectChange(value)}
      slotProps={{
        popper: {
          disablePortal: true,
        },
      }}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props
        return (
          <li key={key} {...optionProps}>
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon />}
              checkedIcon={<CheckBoxIcon />}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.label}
          </li>
        )
      }}
      renderInput={(params) => (
        <TextField {...params} placeholder={filter.label} />
      )}
      disableCloseOnSelect
      multiple
      size="small"
      fullWidth={true}
    />
  )
}

export default FilterSelect
